import React, { useEffect, useState } from 'react';
// import {Link} from 'react-router-dom'
import InputMask from "react-input-mask";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { Input } from '../components/Input'
import { api, apiNew, up, Button, ApiDataTa, getRequestOne } from "../Run"
import { saveAs } from 'file-saver';
import Address from "../components/common/Address";

import moment from 'moment';


import Surname from "../components/common/Surname";

import Name from "../components/common/Name";

import Patron from "../components/common/Patron";

import Logo from '../images/logo2.svg'
import qrNopaper from '../images/qrNopaper.png'

import style from '../components/common/Adress.module.css';


function Opd() {

    let today = new Date();
    let year = today.getFullYear();
    let day = ('0' + today.getDate()).slice(-2);
    let month = ('0' + (today.getMonth() + 1)).slice(-2);

    let [input, setInput] = useState({
        passOrgList: [],
        passOrgListCode: [],
        PDConsentDate: year + '-' + month + '-' + day,
        type: 1,
        "pagePass": "ru",
        "typeDoc": "",
        "FirstName": "",
        "MidName": "",
        'loginEmail': '',
        "LastName": "",
        "bdate": "",
        "inn": "",
        "snils": "",
        "telMob": "",
        "email": "",
        "telHome": "",
        "passNo": "",
        "passSer": "",
        "passDate": "",
        "passOrg": "",
        'passDeptCode': '',
        "address": "",
        "bPlace": "",
    })

    let [error, setError] = useState({ error: false, msg: '', title: '', errors: false })

    let [page, setPage] = useState({ print: false })

    let [data, setData] = useState({})

    let [button, setButton] = useState({ login: false, print: false, up: false })

    let [noPaper, setNoPaper] = useState({})


    let [foc, setFoc] = useState({
        inn: false,
        ogrn: false,
        web: false,
        okpo: false,
        tel: false,
        dataReg: false,
        start: false,
        col: false,
        pass: false,
        kod: false,
        addressPass: false,
        nameU: false,
        disGk: false,
        viewDe: false,
        nameAndInn: false,
        infoDoc: false,
        nameKre: false,
        dataEnd: false,
        ros: false,
        nameBank: false
    })


    let change = (e) => {
        setInput(input => ({ ...input, [e.target.name]: e.target.value }))
        if (e.target.name === "passDeptCode") {
            ApiDataTa(e.target.value).then((d) => {
                if (d.suggestions.length > 0) {
                    console.log(d.suggestions);
                    setInput(input => ({ ...input, passOrgListCode: d.suggestions }))
                }
            })
        }

        if (e.target.name === "passOrg") {
            ApiDataTa(e.target.value).then((d) => {
                if (d.suggestions.length > 0) {
                    console.log(d.suggestions);
                    setInput(input => ({ ...input, passOrgList: d.suggestions }))
                }
            })
        }
        e.persist()
    }

    let codeOrg = (d, code) => {
        setInput(input => ({ ...input, passOrgList: [], passOrg: d, passDeptCode: code }))
    }

    let params = (new URL(document.location)).searchParams;

    let [root, setRoot] = useState(false)


    // console.log(moment('2023-28-11','YYYY-DD-MM').isValid().format('YYYY-MM-DD'))


    useEffect(() => {


        if (params.get("linkCode")) {
            setButton(button => ({ ...button, login: true }))

            getRequestOne('https://api.stone-xxi.ru/checkOffice').then(checkOffice => {

                if (checkOffice?.status && checkOffice?.jwt) {
                    enterOpd(checkOffice?.jwt)
                } else {
                    setButton(button => ({ ...button, login: false }))
                }

            }).catch(() => {
                setButton(button => ({ ...button, login: false }))
            })
        }

    }, [])

    const enterOpd = (jwt) => {


        setButton(button => ({ ...button, login: true }))
        api('tem', { linkCode: params.get("linkCode"), email: input.loginEmail, jwt: jwt }).then((d) => {

            return d

        }).then((d) => {

            if (d.Error) {
                setError(error => ({ ...error, error: true, msg: d.Error, title: d.title }))
                setButton(button => ({ ...button, login: false }))
            } else if (d.error) {
                setError(error => ({ ...error, error: true, msg: d.error.error, title: 'Внимание!' }))
                setButton(button => ({ ...button, login: false }))
            } else {
                apiNew('/GitLkApi/public/api/opd', {
                    linkCode: params.get("linkCode"),
                    email: input.loginEmail
                }).then((dd) => {



                    setError(error => ({ ...error, error: false, msg: '', title: '' }))
                    delete d.Get;

                    let newPassDate = new Date(d.passDate);
                    let newBdate = new Date(d.bdate);
                    setInput(input => ({
                        ...input, ...d, passOrgList: [],
                        serno: d.serno ? d.serno : d.passSer + ' ' + d.passNo,
                        passDate: newPassDate ? newPassDate.getFullYear() + '-' + ('0' + (newPassDate.getMonth() + 1)).slice(-2) + '-' + ('0' + newPassDate.getDate()).slice(-2) : '',
                        bdate: newBdate ? newBdate.getFullYear() + '-' + ('0' + (newBdate.getMonth() + 1)).slice(-2) + '-' + ('0' + newBdate.getDate()).slice(-2) : '',
                        PDConsentDate: d.PDConsentDate ? moment(d.PDConsentDate).format('YYYY-MM-DD') : year + '-' + month + '-' + day,
                        type: 1, linkCode: params.get("linkCode")
                    }))

                    if (dd?.NoPaperDocumentId) {
                        setNoPaper(noPaper => ({ ...noPaper, listFile: dd?.listFile, new: dd?.new, NoPaperDocumentId: dd?.NoPaperDocumentId, statusText: dd?.statusText, status: dd?.status }))
                    }

                    setRoot(true)


                    setButton(button => ({ ...button, login: false }))


                })

            }


        })


    }

    let opd = (e) => {

        enterOpd()

        e.preventDefault()
    }

    const satusDoc = (e) => {

        setButton(button => ({ ...button, statusDoc: true }))

        apiNew('/GitLkApi/public/api/opd', {
            linkCode: params.get("linkCode"),
            email: input.loginEmail
        }).then((d) => {

            if (d?.NoPaperDocumentId) {
                setNoPaper(noPaper => ({ ...noPaper, listFile: d?.listFile, new: d?.new, NoPaperDocumentId: d?.NoPaperDocumentId, statusText: d?.statusText, status: d?.status }))
            }


            setButton(button => ({ ...button, statusDoc: false }))

        })
        e.preventDefault()
    }

    const docClose = (e) => {
        setButton(button => ({ ...button, docClose: true }))

        apiNew('/GitLkApi/public/api/opd/docClose', {
            linkCode: params.get("linkCode"),
            email: input.loginEmail
        }).then((d) => {

            if (d?.NoPaperDocumentId) {
                setNoPaper(noPaper => ({ ...noPaper, listFile: d?.listFile, new: d?.new, NoPaperDocumentId: d?.NoPaperDocumentId, statusText: d?.statusText, status: d?.status }))
            }


            setButton(button => ({ ...button, docClose: false }))

        })
        e.preventDefault()
    }



    const dowFile = (fileId) => {


        apiNew('/GitLkApi/public/api/opd/dowFile', {
            linkCode: params.get("linkCode"),
            email: input.loginEmail,
            fileId: fileId
        }).then((d) => {

            if (d?.response?.fileInfoList[0]?.fileBase64 && d?.response?.fileInfoList[0]?.fileNameWithExtension) {

                saveAs(atob(d?.response?.fileInfoList[0]?.fileBase64), d?.response?.fileInfoList[0]?.fileNameWithExtension);

            }
        })


    }

    let print = (e) => {


        let gg = new Date(input.passDate).getTime();
        let ff = new Date().setYear(new Date().getFullYear() - 35);
        let uu = + new Date();

        e.preventDefault()

        if (ff <= gg && gg <= uu) {


            setButton(button => ({ ...button, print: true }))
            setError(error => ({ ...error, error: false, msg: '', title: '', errors: false }))
            setTimeout(function () {
                setTimeout(function () {
                    // window.scrollTo(0, 0)
                    api('test', { Put: 'PDConsentEdit', ...input, "action": "Create" }).then((d) => {


                        if (d.data.error) {
                            if (d.data.error.errors) {
                                setError(error => ({ ...error, error: true, msg: d.data.error.error, title: 'Внимание!', errors: d.data.error.errors }))
                            } else {
                                setError(error => ({ ...error, error: true, msg: d.data.error.error, title: 'Внимание!' }))
                            }
                            setButton(button => ({ ...button, print: false }))

                        } else {
                            var win = document.getElementById("test").contentWindow;
                            win.postMessage({ ...input, qr: d.data.QRCodeImg });

                            setError(error => ({ ...error, error: true, msg: d.data.msg, title: 'Внимание!' }))

                            setTimeout(function () {
                                var frm = document.getElementById('test').contentWindow;
                                frm.print();
                                setPage(page => ({ ...page, print: true }))

                                // setButton(button => ({...button, print:false}))
                            }, 200);

                        }

                        setButton(button => ({ ...button, print: false }))
                    })
                }, 0);
            }, 200);



        } else {
            setError(error => ({ ...error, error: true, msg: 'Ошибка даты выдачи паспорта', title: 'Внимание!' }))
            setButton(button => ({ ...button, print: false }))
        }



        // e.preventDefault()
    }


    let save = (e) => {



        let gg = new Date(input.passDate).getTime();
        let ff = new Date().setYear(new Date().getFullYear() - 35);
        let uu = + new Date();


        e.preventDefault()

        if (ff <= gg && gg <= uu) {


            setButton(button => ({ ...button, print: true }))
            setError(error => ({ ...error, error: false, errors: false, msg: '', title: '' }))


            api('test', { Put: 'PDConsentEdit', ...{ ...input, telMob: '+' + chTel(input.telMob) }, "action": "Create" }).then((d) => {


                if (d.data.error) {
                    if (d.data.error.errors) {
                        setError(error => ({ ...error, error: true, msg: d.data.error.error, title: 'Внимание!', errors: d.data.error.errors }))
                    } else {
                        setError(error => ({ ...error, error: true, msg: d.data.error.error, title: 'Внимание!' }))
                    }
                    setButton(button => ({ ...button, print: false }))

                } else {

                    setError(error => ({ ...error, error: true, msg: d.data.msg, title: 'Внимание!' }))
                    setPage(page => ({ ...page, print: true }))
                }

                setButton(button => ({ ...button, print: false }))

            })





        } else {
            setError(error => ({ ...error, error: true, msg: 'Ошибка даты выдачи паспорта', title: 'Внимание!' }))
            setButton(button => ({ ...button, print: false }))

        }



        // e.preventDefault()
    }



    let dow = (e) => {
        setButton(button => ({ ...button, dow: true }))
        setTimeout(function () {
            setTimeout(function () {
                // window.scrollTo(0, 0)
                api('test', { Put: 'PDConsentEdit', ...input, "action": "Create" }).then((d) => {
                    var win = document.getElementById("test").contentWindow;
                    win.postMessage({ ...input, qr: d.data.QRCodeImg });
                    if (d.data.error) {
                        setError(error => ({ ...error, errors: d.data.error }))
                        setButton(button => ({ ...button, dow: false }))
                    } else {

                        setTimeout(function () {
                            var frm = document.getElementById('test').contentWindow;


                            var FileSaver = require('file-saver');
                            var blob = new Blob([frm.document.getElementsByTagName('html')[0].innerHTML], { type: "text/plain;charset=utf-8" });
                            FileSaver.saveAs(blob, "opd.doc");
                            setButton(button => ({ ...button, dow: false }))

                        }, 200);

                    }
                })
            }, 0);
        }, 200);

        e.preventDefault()
    }




    let rrr = (e) => {



        let gg = new Date(input.passDate).getTime();
        let ff = new Date().setYear(new Date().getFullYear() - 35);
        let uu = + new Date();

        e.preventDefault()

        if (ff <= gg && gg <= uu) {


            setButton(button => ({ ...button, print: true }))
            setError(error => ({ ...error, error: false, msg: '', title: '' }))


            api('test', { Put: 'PDConsentEdit', ...input, "action": "Create" }).then((d) => {


                if (d.data.error) {
                    if (d.data.error.errors) {
                        setError(error => ({ ...error, error: true, msg: d.data.error.error, title: 'Внимание!', errors: d.data.error.errors }))
                    } else {
                        setError(error => ({ ...error, error: true, msg: d.data.error.error, title: 'Внимание!' }))
                    }
                    setButton(button => ({ ...button, print: false }))

                } else {

                    setError(error => ({ ...error, error: true, msg: d.data.msg, title: 'Внимание!' }))
                    setPage(page => ({ ...page, print: true }))



                    document.getElementById('my_file').click();





                }

                setButton(button => ({ ...button, print: false }))

            })





        } else {
            setError(error => ({ ...error, error: true, msg: 'Ошибка даты выдачи паспорта', title: 'Внимание!' }))
            setButton(button => ({ ...button, print: false }))

        }
    }


    let upload = (e) => {



        setError(error => ({ ...error, errorFile: '' }))


        setButton(button => ({ ...button, up: true }))
        // const file = e.target.files[0];
        // let formData = new FormData();
        // formData.append('file', file);

        //                 up('ul',formData).then((d) => {
        //             console.log(d);
        //         })
        let file = e.target.files
        let temp = [];

        if (file) {

            //     let formData = new FormData();
            //     formData.append('file', file[0])

            //         api('ul',{linkCode:params.get("linkCode"),file:formData}).then((d) => {
            //             console.log(d);
            //         })

            for (let index = 0; index < file.length; index++) {

                setError(error => ({ ...error, error: false, msg: '', title: 'Внимание!' }))
                let reader = new FileReader()
                reader.readAsDataURL(file[index])
                reader.onload = () => {

                    temp = [...temp, { file: reader.result, name: file[index].name }]


                    // api('ul',{linkCode:params.get("linkCode"),file:reader.result,type:file.name.match(/\.[0-9a-z]+$/i)[0]}).then((d) => {
                    if ((index + 1) === file.length) {
                        api('upload', { AppLeasingId: 0, files: temp, linkCode: params.get("linkCode") }).then((d) => {

                            document.getElementById('my_file').value = "";

                            if (d.error) {
                                setError(error => ({ ...error, errorFile: d.error }))
                            } else {
                                setData(data => ({ ...data, file: true, fileUrl: d.url }))
                                setButton(button => ({ ...button, up: false }))

                                if (input.type === 1) {
                                    api('test', { Put: 'PDConsentEdit', "action": "LoadScan", "linkCode": params.get("linkCode"), "files": [d.url] }).then((d) => {
                                        console.log(d);
                                        if (d.data.error) {
                                            setError(error => ({ ...error, error: true, msg: d.data.error.error, title: 'Внимание!' }))
                                        } else {
                                            setError(error => ({ ...error, errorFile: d.data.msg ? d.data.msg : 'Документ отправлен менеджеру, после рассмотрения с Вами свяжутся' }))
                                        }

                                        console.log(d.data.error);
                                    })
                                } else {
                                    setError(error => ({ ...error, errorFile: '' }))
                                    api('test', { Put: 'PDConsentEdit', "action": "LoadDocESign", "linkCode": params.get("linkCode"), "files": [d.url] }).then((d) => {
                                        console.log(d);
                                        if (d.data.error) {
                                            setError(error => ({ ...error, errors: d.data.error }))
                                        } else {
                                            setError(error => ({ ...error, errorFile: d.data.msg ? d.data.msg : 'Документ отправлен менеджеру, после рассмотрения с Вами свяжутся' }))
                                        }
                                    })
                                }
                            }



                        })
                    }

                }
            }
            //     console.log(file);
        } else {
            setButton(button => ({ ...button, up: false }))
        }












    }


    let chTel = (t) => {

        if (t) {
            t = t.replace(/[^\d]/g, '')

            if (t.length == 11) {
                if (t.toString()[0] !== 7) {
                    t = 7 + t.slice(1)
                    t = t.substr(0, 1) + '(' + t.substr(1, 3) + ')' + t.substr(4, 3) + '-' + t.substr(7, 2) + '-' + t.substr(9, 2)
                    return t
                } else {
                    t = t.substr(0, 1) + '(' + t.substr(1, 3) + ')' + t.substr(4, 3) + '-' + t.substr(7, 2) + '-' + t.substr(9, 2)
                    return t
                }
            } else if (t.length <= 11) {
                if (t.toString()[0] != 7) {
                    t = 7 + t
                    t = t.substr(0, 1) + '(' + t.substr(1, 3) + ')' + t.substr(4, 3) + '-' + t.substr(7, 2) + '-' + t.substr(9, 2)
                    return t
                } else {
                    t = t.substr(0, 1) + '(' + t.substr(1, 3) + ')' + t.substr(4, 3) + '-' + t.substr(7, 2) + '-' + t.substr(9, 2)
                    return t
                }
            } else {
                return ''
            }

        } else {
            return ''
        }


    }


    const onChangeAddress = (value) => {
        setInput(input => ({ ...input, address: value }))
    }


    const onChangeSurname = (value) => {
        setInput(input => ({ ...input, LastName: value }))
    }

    const onChangeName = (value) => {
        setInput(input => ({ ...input, FirstName: value }))
    }

    const onChangePatron = (value) => {
        setInput(input => ({ ...input, MidName: value }))
    }

    const onBlur = () => {
        setTimeout(() => {
            setInput(input => ({ ...input, passOrgList: [], passOrgListCode: [] }))
        }, 200);

    }

    const sign = (e) => {

        let gg = new Date(input.passDate).getTime();
        let ff = new Date().setYear(new Date().getFullYear() - 35);
        let uu = + new Date();


        e.preventDefault()

        if (ff <= gg && gg <= uu) {


            setButton(button => ({ ...button, print: true }))
            setError(error => ({ ...error, error: false, errors: false, msg: '', title: '' }))


            api('test', { Put: 'PDConsentEdit', ...{ ...input, telMob: '+' + chTel(input.telMob) }, "action": "Create" }).then((d) => {


                if (d.data.error) {
                    if (d.data.error.errors) {
                        setError(error => ({ ...error, error: true, msg: d.data.error.error, title: 'Внимание!', errors: d.data.error.errors }))
                    } else {
                        setError(error => ({ ...error, error: true, msg: d.data.error.error, title: 'Внимание!' }))
                    }
                    setButton(button => ({ ...button, print: false }))

                    return

                } else {

                    setError(error => ({ ...error, error: true, msg: d.data.msg, title: 'Внимание!' }))
                    setPage(page => ({ ...page, print: true }))

                    return d.data.QRCodeImg
                }


            }).then((d) => {

                if (d) {
                    apiNew('/GitLkApi/public/api/opd/sign', {

                        linkCode: params.get("linkCode"),
                        phone: input.telMob,
                        email: input.email,
                        name: input.FirstName,
                        surname: input.LastName,
                        patronymic: input.MidName,
                        sopd: JSON.stringify(input),
                        qr: d

                    }).then((d) => {

                        if (d?.NoPaperDocumentId) {
                            setNoPaper(noPaper => ({ ...noPaper, listFile: d?.listFile, NoPaperDocumentId: d?.NoPaperDocumentId, new: d?.new, statusText: d?.statusText, status: d?.status, phone: d?.phone }))
                        }

                        setButton(button => ({ ...button, print: false }))

                    })
                } else {

                    setButton(button => ({ ...button, print: false }))

                }

            })





        } else {
            setError(error => ({ ...error, error: true, msg: 'Ошибка даты выдачи паспорта', title: 'Внимание!' }))
            setButton(button => ({ ...button, print: false }))

        }


    }


    const disStatus = (status) => status === 6 || status === 4 || !status ? false : true


    return <>
        <header class="header">
            <a class="header-logo" style={{ background: '#F2F2F2' }} href="/"><img class="header-logo__img" src={Logo} /></a>
            <div class="header-inner" style={{ background: '#F2F2F2' }}>






            </div>

        </header>



        <main class="main">



            <div class="content-page" style={{ margin: '0 auto', maxWidth: '1200px' }}>
                <div class="content-main pb-0">


                    <div class="page-head mb-4">Согласие на обработку персональных данных</div>
                    <div class="row">
                        {root ? <> <div class="col-lg-5 col-md-8">
                            {/* <form onSubmit={save}> */}
                            {/* <div class="form-group mb-3 form-floating">
			<input class="form-control" placeholder="Иванов" name="LastName" value={input.LastName}  onChange={change}  />
			<label>Фамилия</label>
		</div> */}
                            <Surname
                                value={input.LastName}
                                name='LastName'
                                onChange={onChangeSurname}
                                tooltipText='Фамилия'
                                label='Фамилия'
                                className='form-control'
                                autoComplete='off'
                                disabled={disStatus(noPaper.status)}
                            />
                            <div class="row">
                                <div class="col-md-6">
                                    {/* <div class="form-group mb-3 form-floating">
					<input class="form-control" placeholder="Иванов" name="FirstName" value={input.FirstName} onChange={change} />
					<label>Имя</label>
				</div> */}

                                    <Name
                                        value={input.FirstName}
                                        name='FirstName'
                                        onChange={onChangeName}
                                        tooltipText='Имя'
                                        label='Имя'
                                        className='form-control'
                                        autoComplete='off'
                                        disabled={disStatus(noPaper.status)}
                                    />
                                </div>
                                <div class="col-md-6">
                                    {/* <div class="form-group mb-3 form-floating">
					<input class="form-control" placeholder="Иванов" name="MidName" value={input.MidName} onChange={change} />
					<label>Отчество</label>
				</div> */}

                                    <Patron
                                        value={input.MidName}
                                        name='MidName'
                                        onChange={onChangePatron}
                                        tooltipText='Отчество'
                                        label='Отчество'
                                        className='form-control'
                                        autoComplete='off'
                                        disabled={disStatus(noPaper.status)}
                                    />
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mb-3 form-floating">
                                        <input disabled={disStatus(noPaper.status)} class="form-control" placeholder="Иванов" name="bdate" value={input.bdate} onChange={change} max="2999-12-31" type="date" />
                                        <label>Дата рождения</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mb-3 form-floating">
                                        <input disabled={disStatus(noPaper.status)} class="form-control" placeholder="Иванов" name="bPlace" value={input.bPlace} onChange={change} />
                                        <label>Место рождения</label>
                                    </div>
                                </div>
                            </div>
                            <h6 class="mt-1">Паспорт, СНИЛС, ИНН</h6>
                            <hr size="2" />
                            <div class="form-group mb-3 form-floating">
                                <InputMask disabled={disStatus(noPaper.status)} mask="9999 999999" name="serno" class="form-control" onFocus={() => setFoc(foc => ({ ...foc, pass: true }))} onBlur={() => setFoc(foc => ({ ...foc, pass: false }))} onChange={change} value={input.serno} type="text" />
                                {/* <input class="form-control" placeholder="Иванов" /> */}
                                <label>Серия и номер паспорта</label>
                            </div>
                            <div class="form-group mb-3 form-floating">
                                <input disabled={disStatus(noPaper.status)} class="form-control" placeholder="Иванов" name="passOrg" autoComplete='off' onBlur={onBlur} value={input.passOrg} onChange={change} />
                                <label>Место выдачи</label>
                            </div>
                            {input.passOrgList.length > 0 && <div className={style.dropDown}>{input.passOrgList.map((d, i) => {
                                return <div key={i} onClick={() => codeOrg(d.value, d.data.code)} className={style.dropDown__item} >{d.value}</div>
                            })}</div>}
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mb-3 form-floating">
                                        <input disabled={disStatus(noPaper.status)} class="form-control" placeholder="Иванов" name="passDate" value={input.passDate} onChange={change} max="2999-12-31" type="date" />
                                        <label>Дата выдачи</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mb-3 form-floating">
                                        {/* <input class="form-control" placeholder="Иванов" value="Иванович" /> */}
                                        <InputMask disabled={disStatus(noPaper.status)} class="form-control" mask="999-999" name='passDeptCode' value={input.passDeptCode} autoComplete='off' onBlur={onBlur} onChange={change} type="text" />
                                        <label>Код подразделения</label>
                                    </div>
                                    {input.passOrgListCode.length > 0 && <div className={style.dropDown}>{input.passOrgListCode.map((d, i) => {
                                        return <div key={i} onClick={() => codeOrg(d.value, d.data.code)} className={style.dropDown__item} >{d.value}</div>
                                    })}</div>}
                                </div>





                            </div>

                            {/* <input class="form-control" placeholder="Иванов" /> */}
                            {/* <label>Адрес регистрации</label> */}
                            <Address
                                value={input.address}
                                name='address'
                                onChange={onChangeAddress}
                                tooltipText='Адрес постоянной регистрации, указанный в паспорте'
                                label='Адрес регистрации (по паспорту)'
                                className='form-control'
                                disabled={disStatus(noPaper.status)}
                            />

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mb-3 form-floating">
                                        <InputMask disabled={disStatus(noPaper.status)} mask="999999999999" class="form-control" onFocus={() => setFoc(foc => ({ ...foc, inn: true }))} autoComplete='off' onBlur={() => setFoc(foc => ({ ...foc, inn: false }))} name="inn" value={input.inn} onChange={change} type="text" />
                                        <label>ИНН</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mb-3 form-floating">
                                        <InputMask disabled={disStatus(noPaper.status)} mask="999-999-999 99" class="form-control" name="snils" value={input.snils} onChange={change} autoComplete='off' type="text" />

                                        <label>СНИЛС</label>
                                    </div>
                                </div>
                            </div>
                            <h6 class="mt-1">Контакты</h6>
                            <hr size="2" />
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mb-3 form-floating">
                                        {/* <input class="form-control" placeholder="+7 (495) 777-77-77" value="Иван" /> */}
                                        <InputMask disabled={disStatus(noPaper.status)} class="form-control" mask="+7 999 999 9999" name="telMob" value={input.telMob} onChange={change} type="text" />
                                        <label>Телефон</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mb-3 form-floating">
                                        <input disabled={disStatus(noPaper.status)} class="form-control" placeholder="Иванов" name="email" value={input.email} onChange={change} />
                                        <label>E-mail</label>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-2">

                                {!disStatus(noPaper.status) && <div>



                                    {error.error && <div className='login-alert p-3 text-center mb-3'><div className='text-primary'>{error.title}</div>{error.msg}</div>}
                                    {error.errors && <div className='login-alert p-3 pb-0 text-center mb-3'>
                                        <div style={{ textAlign: 'left' }}>
                                            <ul>{error.errors.map((d, i) => { return <li key={i}>{d.text}</li> })}</ul>
                                        </div>
                                    </div>}

                                    {/* <button className="btn btn-ref d-flex align-items-center line-height-1_2 mb-3" disabled><i class="icon-download me-2"></i>Скачать согласие об обработке персональных данных</button> */}
                                    {/* <button className="btn btn-ref d-flex align-items-center line-height-1_2 mt-4 mb-4" onClick={print}><i class="icon-print me-2"></i>Распечатать</button> */}
                                    <button class="btn btn-base mb-3 me-2" onClick={save} disabled={button.print}>
                                        <Button title='Сохранить' color='btn-black-base' param={button.print} />
                                    </button>

                                    <button className="btn btn-ghost mb-3" onClick={print} disabled={button.print}><i class="icon-print me-2"></i>Распечатать</button>


                                    {error.errorFile && <div className='login-alert p-3 text-center mb-3 mt-3'><div className='text-primary'>Внимание!</div>{error.errorFile}
                                    </div>}


                                    <input type="file" id="my_file" onChange={upload} multiple />
                                    <div class="col-auto"><button type='button' className="btn btn-ghost" disabled={button.print} onClick={rrr}>Загрузить с обычной подписью</button></div>

                                    <div class="mt-3 mb-3">
                                        * ВНИМАНИЕ! Сохраняйте оригинал документа для получения предмета лизинга.
                                    </div>

                                </div>}

                                <div class="row">


                                    <div class="col-12">
                                        <h6 class="mt-0">ЭЦП</h6>
                                        <hr size="2" />
                                    </div>


                                    <div class="col">

                                        {noPaper.NoPaperDocumentId && !(!noPaper.status || noPaper.status === 4 || noPaper.status === 6) ? <div>

                                            {(noPaper.statusText && noPaper.status === 3) && <div className='alert-success p-3 text-center mb-3'><div className='text-primary'>Статус</div>{noPaper.statusText}</div>}

                                            {(noPaper.statusText && noPaper.status !== 3) && <div className='login-alert p-3 text-center mb-3'><div className='text-primary'>Статус</div>{noPaper.statusText}</div>}


                                            {noPaper.new ? <>

                                                {noPaper.status === 2 && <div class='newBox'>
                                                    <div className='row'>
                                                        <div className='col-auto'>
                                                            <div className='num'>1</div>
                                                        </div>
                                                        <div className='col numTitle'>
                                                            Скачайте приложение по QR коду и авторизуйтесь в сервисе <a href='https://nopaper.ru/edo' target="_blank">Nopaper</a>. Пароль выслан в СМС на Ваш телефон {input.telMob}
                                                            <div style={{ width: '100%' }} className='py-4'>

                                                                <img class="qrNopaper" src={qrNopaper} />

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row mb-3'>
                                                        <div className='col-auto'>
                                                            <div className='num'>2</div>
                                                        </div>
                                                        <div className='col numTitle'>
                                                            Подпишите документ НЭП в мобильном приложении <a href='https://nopaper.ru/edo' target="_blank">Nopaper</a>.
                                                        </div>
                                                    </div>

                                                    {/* <div className='row'>
                                                    <div className='col-auto'>
                                                        <div className='num'>3</div>
                                                    </div>
                                                    <div className='col numTitle'>
                                                        Нажмите на кнопку <b>"Обновить статус"</b>
                                                    </div>
                                                </div> */}

                                                </div>}

                                            </> : <>
                                                {noPaper.status === 2 && <div class='newBox'>
                                                    <div className='row'>
                                                        <div className='col-auto'>
                                                            <div className='num'>1</div>
                                                        </div>
                                                        <div className='col numTitle'>

                                                            Если вы еще не авторизованы в мобильном приложение <a href='https://nopaper.ru/edo' target="_blank">Nopaper</a>, пройдите процедуру авторизации.

                                                            {/* <div style={{ width: '100%' }} className='py-4'>

                                                                <img class="qrNopaper" src={qrNopaper} />

                                                            </div> */}
                                                        </div>
                                                    </div>
                                                    <div className='row mb-3'>
                                                        <div className='col-auto'>
                                                            <div className='num'>2</div>
                                                        </div>
                                                        <div className='col numTitle'>
                                                            Подпишите документ НЭП в мобильном приложении <a href='https://nopaper.ru/edo' target="_blank">Nopaper</a>.
                                                        </div>
                                                    </div>

                                                    {/* <div className='row'>
                                                    <div className='col-auto'>
                                                        <div className='num'>3</div>
                                                    </div>
                                                    <div className='col numTitle'>
                                                        Нажмите на кнопку <b>"Обновить статус"</b>
                                                    </div>
                                                </div> */}

                                                </div>}
                                            </>}

                                            {(noPaper.status !== 3) &&
                                                <div>
                                                    <button className="btn btn-base me-2 mb-3" onClick={satusDoc} disabled={button.statusDoc}>

                                                        <Button title='Обновить статус' color='btn-black-base' param={button.statusDoc} />

                                                    </button>

                                                    <button className="btn btn-ghost me-2 mb-3" onClick={docClose} disabled={button.docClose || button.statusDoc}>
                                                        <Button title='Отклонить' color='btn-black-base' param={button.docClose} />
                                                    </button>

                                                    <div className="mb-3">* Для отмены подписания при помощи ЭЦП нажмите кнопку Отклонить</div>
                                                </div>
                                            }


                                            {/* {noPaper.listFile && <div>

                                                {noPaper.listFile.ofertaList && noPaper.listFile.ofertaList.length !== 0 &&
                                                    noPaper.listFile.ofertaList.map((d, i) => <div><button key={i} onClick={(e) => dowFile(d.fileId)}  className="btn btn-ref me-2 mb-1 text-start">{d.originNameWithExtension}</button></div>)
                                                }

                                                {noPaper.listFile.originFileList && noPaper.listFile.originFileList.length !== 0 &&
                                                    noPaper.listFile.originFileList.map((d, i) => <div><button key={i} onClick={(e) => dowFile(d.fileId)} className="btn btn-ref me-2 mb-1 text-start">{d.originNameWithExtension}</button></div>)
                                                }

                                                {noPaper.listFile.kedoXmlList && noPaper.listFile.kedoXmlList.length !== 0 &&
                                                    noPaper.listFile.kedoXmlList.map((d, i) => <div><button key={i} onClick={(e) => dowFile(d.fileId)}  className="btn btn-ref me-2 mb-1 text-start">{d.originNameWithExtension}</button></div>)
                                                }

                                                {noPaper.listFile.ofertaWithStampList && noPaper.listFile.ofertaWithStampList.length !== 0 &&
                                                    noPaper.listFile.ofertaWithStampList.map((d, i) => <div><button key={i} onClick={(e) => dowFile(d.fileId)}  className="btn btn-ref me-2 mb-1 text-start">{d.originNameWithExtension}</button></div>)
                                                }

                                                {noPaper.listFile.originFileWithStampList && noPaper.listFile.originFileWithStampList.length !== 0 &&
                                                    noPaper.listFile.originFileWithStampList.map((d, i) => <div><button key={i} onClick={(e) => dowFile(d.fileId)}  className="btn btn-ref me-2 mb-1 text-start">{d.originNameWithExtension}</button></div>)
                                                }

                                                {noPaper.listFile.procuratoryList && noPaper.listFile.procuratoryList.length !== 0 &&
                                                    noPaper.listFile.procuratoryList.map((d, i) => <div><button key={i} onClick={(e) => dowFile(d.fileId)}  className="btn btn-ref me-2 mb-1 text-start">{d.originNameWithExtension}</button></div>)
                                                }

                                                {noPaper.listFile.procuratoryWithStampList && noPaper.listFile.procuratoryWithStampList.length !== 0 &&
                                                    noPaper.listFile.procuratoryWithStampList.map((d, i) => <div><button key={i} onClick={(e) => dowFile(d.fileId)}  className="btn btn-ref me-2 mb-1 text-start">{d.originNameWithExtension}</button></div>)
                                                }


                                            </div>} */}

                                        </div> : <div className='mb-3'>

                                            <div>
                                                <button className="btn btn-base me-2 mb-3" onClick={sign} disabled={button.print}>Подписать ЭЦП в сервисе Nopaper</button>
                                            </div>
                                            <a href='https://nopaper.ru/edo' target="_blank" className='btn btn-ghost me-2 '>О сервисе Nopaper</a>

                                            <img style={{ width: '90px' }} src="https://np-demo.abanking.ru/assets/icons-color/nopaper-logo-main.svg"></img>
                                        </div>}

                                    </div>




                                    {/* <div class="col-auto mb-4">

                                        <button className="btn btn-ref">Загрузить с ЭЦП</button>

                                    </div> */}




                                </div>
                            </div>

                            {/* </form> */}
                        </div></> : <div class="col-lg-5 col-md-8">
                            {error.error && <div className='login-alert p-3 text-center mb-3'><div className='text-primary'>{error.title}</div>{error.msg}</div>}


                            <form>
                                <div class="form-group mb-3 form-floating">
                                    <input class="form-control" name="loginEmail" onChange={change} value={input.loginEmail} placeholder="Иванов" />
                                    <label>E-mail или Фамилия</label>
                                </div>

                                <div class="mt-4 mb-4">
                                    <button class="btn btn-base" onClick={opd} disabled={button.login}><Button title='Продолжить' color='btn-black-base' param={button.login} /></button>
                                </div>
                            </form>
                        </div>}



                        <div class="col-lg-7 col-md-8">
                            <h6>Согласие на обработку персональных данных руководителя можно подписать с помощью ЭЦП.</h6>


                            <div>

                                <ul>
                                    <li class="mb-1">Согласие на обработку персональных данных может быть подписано в <a href='https://play.google.com/store/apps/details?id=com.abanking.nopaperlkk' target='_blank'>мобильном приложении Nopaper</a> с помощью НЭП (неквалифицированной электронной подписи), которую для вас, как для физического лица, бесплатно сформирует <a href='https://nopaper.ru/edo/' target='_blank'>сервис Nopaper</a>.</li>
                                    <li class="mb-1">Согласие на обработку персональных данных можно подписать в компьютере с помощью КЭП (квалифицированной электронной подписи) в <a href='https://lk.nopaper.ru/account/login' target='_blank'>личном кабинете сервиса Nopaper</a>. Для этого: </li>
                                </ul>
                            </div>


                            <div>
                                <ul className='me-5'>
                                    <li class="mb-1 me-5">У вас на usb-токене должны быть записан сертификат электронной подписи для физического лица, выданный  ФНС или удостоверяющим центром.</li>
                                    <li class="mb-1 me-5">На компьютере должен быть установлен криптопровайдер (КриптоПро, ViPNet, Signal-COM и т.п. ).</li>
                                    <li class="mb-1 me-5">Для браузера должен быть установлен plug-in для работы с электронной подписью. </li>
                                    <li class="mb-1 me-5">Нужно зарегистрироваться и пройти процедуру авторизации в <a href='https://play.google.com/store/apps/details?id=com.abanking.nopaperlkk' target='_blank'>мобильном приложении Nopaper</a>.</li>



                                </ul>
                            </div>


                            <p>
                                <b>
                                    Продолжая использовать сервис, я соглашаюсь с <a href='https://www.stone-xxi.ru/terms-of-use/' target='_blank'>Правилами пользования</a> и <a href='https://www.stone-xxi.ru/privacy-policy/' target='_blank'>Политикой конфиденциальности и обработки персональных данных</a>
                                </b>
                            </p>



                            {/* <p align="justify">Настоящим я (Пользователь), во исполнение требований законодательства о персональных данных, а также законодательства о рекламе, действуя свободно, своей волей и в своем интересе даю своё согласие Обществу с ограниченной ответственностью «Лизинговая компания «СТОУН-XXI» (далее – ООО «СТОУН-XXI») (ОГРН 1027739641710, ИНН 7710329843), с местом нахождения: Российская Федерация, 123056, г. Москва, Малый Тишинский пер. д.14-16, почтовым адресом Российская Федерация, 117105, г. Москва, ул. Нагатинская, д. 1, на обработку своих персональных данных, указанных при регистрации и/или оставлении заявки на получение расчета лизинга и/или на получение рекламной информации, связанной с договором лизинга и лизинговой деятельностью (включая рекламу) по любым каналам связи, включая: SMS-оповещение, почтовое письмо, телеграмму, голосовое сообщение (далее – Рассылка) путем заполнения веб-формы на сайте ООО «СТОУН-XXI» (https://www.stone-xxi.ru/) (далее – «Сайт»).</p>
                            <hr size="2" />
                            <h6 class="mt-4">Что такое персональные данные</h6>
                            <p>Под персональными данными понимается любая информация, относящаяся ко мне как к субъекту персональных данных, в том числе:</p>
                            <div class="row">
                                <div class="col-lg-4">
                                    <ul>
                                        <li class="mb-1">фамилия, имя, отчество,</li>
                                        <li class="mb-1">дата и место рождения,</li>
                                        <li class="mb-1">гражданство,</li>
                                        <li class="mb-1">пол,</li>
                                        <li class="mb-1">место работы и должность,</li>
                                        <li class="mb-1">почтовый адрес;</li>
                                        <li class="mb-1">номера рабочего и мобильного телефонов,</li>
                                        <li class="mb-1">адреса электронной почты,</li>
                                    </ul>
                                </div>
                                <div class="col-lg-4">
                                    <ul>
                                        <li class="mb-1">данные водительского удостоверения,</li>
                                        <li class="mb-1">адрес регистрации по месту жительства,</li>
                                        <li class="mb-1">адрес фактического проживания,</li>
                                        <li class="mb-1">паспортные данные,</li>
                                        <li class="mb-1">данные, которые относятся (могут быть отнесены) к категории биометрические персональные данные,</li>
                                    </ul>
                                </div>
                                <div class="col-lg-4">
                                    <ul>
                                        <li class="mb-1">идентификационный номер налогоплательщика,</li>
                                        <li class="mb-1">номер страхового свидетельства обязательного пенсионного страхования,</li>
                                        <li class="mb-1">иные персональные данные, в том числе полученные посредством заполнения заявки расчета лизинга на Сайте.</li>
                                    </ul>
                                </div>
                            </div>
                            <hr size="2" />
                            <h6 class="mt-4">Цели сбора и обработки персональных данных</h6>
                            <p align="justify">Целями обработки, в том числе целями сбора, персональных данных являются: определение возможности заключения договоров лизинга, договоров страхования (страховых полисов), договоров купли-продажи, любых иных договоров, необходимых для реализации договора лизинга, их заключения, изменения, исполнения и прекращения, продвижения лизинговых и иных услуг посредством любых средств связи, а также для обеспечения соблюдения законов и иных нормативно-правовых актов.</p>
                            <hr size="2" />
                            <h6 class="mt-4">Соглашение</h6>
                            <p align="justify">Я согласен (а) с тем, что в рамках обработки персональных данных ООО «СТОУН-XXI» вправе осуществлять сбор, запись, систематизацию, накопление, анализ, использование, извлечение, распространение, передачу любым иным третьим лицам, в том числе и трансграничную передачу, получение, обработку, хранение, уточнение (обновление, изменение), обезличивание, блокирование, удаление, уничтожение моих персональных данных путем ведения баз данных автоматизированным, механическим, ручным способами в целях: ведения и актуализации клиентской базы; получения и исследования статистических данных об объемах продаж и качестве оказываемых услуг; проведения маркетинговых программ; проведения опросов и исследований, направленных на выявление удовлетворенности/неудовлетворенности Пользователя, постоянного совершенствования уровня предоставляемых услуг; информирования меня о предлагаемых ООО «СТОУН-XXI» автомобилях, оказываемых услугах, проводимых бонусных мероприятий, акций и т.д.; рекламирования и иного любого продвижения товаров и услуг на рынке путем осуществления прямых контактов со мной и иными потребителями; технической поддержки при обработке информации и персональных данных с использованием средств автоматизации и без такого использования.</p>
                            <p align="justify">Я выражаю согласие на получение рекламы и разрешаю ООО «СТОУН-XXI» осуществлять в мой адрес смс-рассылки, а также иные виды рассылок и уведомлений, в том числе рекламного характера, с использованием любых средств связи, в том числе электронной почты.</p>
                            <p align="justify">Я ознакомлен (а), что: настоящее Согласие на обработку моих персональных данных и получение рекламы действует в течение 20 (двадцати) лет, а в части персональных данных, содержащихся в документах и на иных носителях информации, срок хранения которых по действующему законодательству превышает двадцать лет, Согласие на обработку персональных данных действует в течение сроков хранения таких документов и иных носителей информации, установленных действующим законодательством. Согласие на обработку персональных данных может быть отозвано посредством направления соответствующего письменного уведомления в адрес ООО «СТОУН-XXI» по адресу места нахождения, указанному в настоящем согласии. В этом случае лицо, получившее отзыв согласия на обработку персональных данных или согласия на получение рекламы, прекращает обработку персональных данных, а персональные данные подлежат уничтожению или обезличиванию, если отсутствуют иные правовые основания для обработки, установленные законодательством РФ или документами лица, получившего отзыв согласия на обработку персональных данных, регламентирующими вопросы обработки персональных данных. Настоящее Согласие считается отозванным по истечении 30 (тридцати) дней с момента получения ООО «СТОУН-XXI» письменного уведомления об отзыве настоящего согласия. День получения уведомления не включается в 30-тидневный срок.</p>
                            <p align="justify">При изменении адресов электронной почты и/или номеров телефонов, по которым осуществляется Рассылка рекламы, я обязуюсь незамедлительно проинформировать об этом ООО «СТОУН-XXI» об изменении адресов электронной почты и/или номеров телефонов. До указанного уведомления Рассылка осуществляется по адресам электронной почты и номерам телефонов, указанным в веб-форме заявки расчета лизинга на Сайте, а риск связанных с этих последствий принимаю на себя.</p>
                            <p align="justify">Настоящим Согласием я подтверждаю, что являюсь субъектом предоставляемых персональных данных, а также подтверждаю достоверность предоставляемых данных.</p>
                            <p align="justify">Я осознаю, что, регистрируясь и авторизируясь на Сайте, оставляя заявку на получение расчета лизинга и/или подписываясь на получение рекламной информации на Сайте, я выражаю ООО «СТОУН-XXI» своё письменное согласие с условиями, описанными в настоящем Согласии.</p>
                       */}


                        </div>
                    </div>

                    <hr size="2" className='mb-4' />
                </div>

            </div>


        </main>

        <iframe src='/opd/test.html' id='test' width='0' height='0'></iframe>
    </>
}

export default Opd
